<script>
  import { afterUpdate } from "svelte"
  import notify from "../../../../Script/notify"
  import { copyToClipboard } from "../../../Publish/SinglePublish/script"

  export let key = ""
  export let value = ""

  let closeNotification = {
    close() {},
  }

  const keyMappings = {
    C: "COUNTRY",
    O: "ORGANIZATION",
    OU: "ORGANIZATIONAL UNIT",
    CN: "COMMON NAME",
    ST: "STATE",
  }

  const changeCase = (str) => {
    let newStr = str.replace(/_/g, " ")
    return newStr.replace(/([a-z])([A-Z])/g, "$1 $2").toUpperCase()
  }

  const isUrl = (val) => {
    if (typeof val !== "string") return false
    try {
      const parsed = new URL(val)
      return ["http:", "https:"].includes(parsed.protocol)
    } catch {
      return false
    }
  }

  const isOID = (val) => {
    if (typeof val !== "string") return false
    return /^\d+(\.\d+)+$/.test(val.trim())
  }

  afterUpdate(() => {
    key = changeCase(key)

    if (key == "START DATE" || key == "END DATE") {
      value = new Date(new Date(value).getTime() - new Date().getTimezoneOffset() * 60000).toUTCString().slice(0, 26)
    }
  })

  const copyValue = async () => {
    try {
      closeNotification.close()
      let copyText = Array.isArray(value) ? value.join(", ") : value
      await copyToClipboard(copyText)
      closeNotification = notify.info(`${keyMappings[key] || key} copied successfully.`)
    } catch (error) {
      console.error(error)
      const info = `PAGE: Doc Multi-Signer (Status Page)\nEVENT: While copying ${keyMappings[key] || key}`
      closeNotification = notify.danger(error, info)
    }
  }
</script>

<div class="flex w-full gap-3">
  <div class="w-2/5 text-sm text-[#969696]">{keyMappings[key] || key}</div>

  {#if Array.isArray(value)}
    <div class="flex w-3/5 flex-col flex-wrap gap-1 overflow-hidden">
      {#each value as val}
        {#if isUrl(val) || isOID(val)}
          <a href={isOID(val) ? `https://oidref.com/${val}` : val} target="_blank" class="w-full cursor-pointer truncate text-sm text-blue-500 underline dark:text-blue-500">
            {isOID(val) ? val : new URL(val).origin}
          </a>
        {:else}
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <div class="w-full cursor-pointer truncate text-sm text-gray-d00 dark:text-slate-200" on:click={copyValue}>
            {val}
          </div>
        {/if}
      {/each}
    </div>
  {:else if isUrl(value) || isOID(value)}
    <a href={isOID(value) ? `https://oidref.com/${value}` : value} target="_blank" class="w-3/5 cursor-pointer truncate text-sm text-blue-500 underline dark:text-blue-500">
      {isOID(value) ? value : new URL(value).origin}
    </a>
  {:else}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div on:click={copyValue} class="w-3/5 cursor-pointer truncate text-sm text-gray-d00 dark:text-slate-200">
      {value}
    </div>
  {/if}
</div>
